"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROLE_BY_APP_ADDRESS = exports.ORGANIZATION_PERMISSIONS = exports.REPO_BY_APP_ADDRESS = exports.APP_BY_ADDRESS = exports.ORGANIZATION_APPS = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const fragments = __importStar(require("./fragments"));
exports.ORGANIZATION_APPS = (type) => graphql_tag_1.default `
  ${type} Organization($orgAddress: String!, $appFilter: App_filter!, $first: Int) {
    organization(id: $orgAddress) {
      apps(where: $appFilter, first: $first) {
        ...App_app
      }
    }
  }
  ${fragments.APP_FRAGMENT}
`;
exports.APP_BY_ADDRESS = (type) => graphql_tag_1.default `
  ${type} App($appAddress: String!) {
    app(id: $appAddress) {
      ...App_app
    }
  }
  ${fragments.APP_FRAGMENT}
`;
exports.REPO_BY_APP_ADDRESS = (type) => graphql_tag_1.default `
  ${type} App($appAddress: String!) {
    app(id: $appAddress) {
      repo {
        ...Repo_repo
      }
      version {
        ...Version_version
      }
    }
  }
  ${fragments.REPO_FRAGMENT}
  ${fragments.VERSION_FRAGMENT}
`;
exports.ORGANIZATION_PERMISSIONS = (type) => graphql_tag_1.default `
  ${type} Organization($orgAddress: String!) {
    organization(id: $orgAddress) {
      permissions {
        ...Permission_permission
      }
    }
  }
  ${fragments.PERMISSION_FRAGMENT}
`;
exports.ROLE_BY_APP_ADDRESS = (type) => graphql_tag_1.default `
  ${type} App($appAddress: String!) {
    app(id: $appAddress) {
      appId
      version{
        ...Version_version
      }
      roles {
        ...Role_role
      }
    }
  }
  ${fragments.VERSION_FRAGMENT}
  ${fragments.ROLE_FRAGMENT}
`;
//# sourceMappingURL=index.js.map